module.exports = __webpack_public_path__ + "img/service-1.95579ece.png";